import ClickExpandTextModal from "newui/components/ClickExpandTextModal"
import { useState } from "react";
import { CompanyDescriptionModal } from "./CompanyDescriptionModal";
import { Company } from "newui/features/Company/types";

interface CompanyDescriptionExpandProps {
	company: Company;
	isMobile?: boolean;
}

export const CompanyDescriptionExpand = ({ company, isMobile }: CompanyDescriptionExpandProps) => {
	const [aboutModalOpen, setAboutModalOpen] = useState(false);

	return <>
		{/* Description display */}
		<ClickExpandTextModal
			text={company.description}
			title="About"
			maxTextDisplay={isMobile ? 100 : 120}
			isLoading={false}
			setShowModal={setAboutModalOpen}
			titleClassName={isMobile && "text-sm"}
			textClassName={isMobile && "text-sm"}
		/>

		{/* About Modal */}
		<CompanyDescriptionModal
			isOpen={aboutModalOpen}
			onClose={() => setAboutModalOpen(false)}
			name={company.name}
			logoPath={company.logo_path}
			bannerPath={company.banner_path}
			description={company.description}
		/>
	</>
}